import { classNames } from "@/utils/classnames";
import { Transition } from "@headlessui/react";
import React, { CSSProperties, Fragment } from "react";

export function Spinner({
  className,
  size = "sm",
  ...rest
}: { size?: "sm" | "md" | "lg" | "xl" | "2xl" } & React.ComponentProps<"div">) {
  const sizeClasses = {
    sm: "min-w-4 min-h-[14px] w-[14px] h-4 border-[3px]",
    md: "min-w-5 min-h-5 w-5 h-5 border-4",
    lg: "min-w-6 min-h-6 w-6 h-6 border-4",
    xl: "min-w-8 min-h-8 w-8 h-8 border-[6px]",
    "2xl": "w-12 h-12 border-8",
  }[size];
  return (
    <div
      className={classNames(
        "animate-spin inline-block border-zinc-500 border-r-white rounded-full",
        sizeClasses,
        className,
      )}
      role="status"
      {...rest}
    >
      {" "}
    </div>
  );
}

/**
 * Blocks the page while its identity or layout is still indeterminate, such as during
 * route, authentication, or bootstrap resolution. Prefer component-owned skeletons
 * whenever the page can already render its final structure.
 */
export function PageInitializationSpinner({
  className,
  style,
}: {
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <Transition
      show
      as={Fragment}
      // appear
      enter="transition-opacity duration-300 delay-300"
      enterFrom="opacity-0"
      enterTo="opacity-100"
    >
      {/* data-testid: the loading-geometry e2e sweep asserts data-state panes
          render skeleton chrome, not a page-initialization spinner, while loading. */}
      <div
        className={classNames("flex items-center justify-center p-8 flex-1", className)}
        data-testid="page-initialization-spinner"
        style={style}
      >
        <Spinner size="xl" />
      </div>
    </Transition>
  );
}
